import axiosInstance from "./axiosConfig";
import { handleAPIError } from "./utils/errors";

export interface CreateDocumentRequest {
  individual_id: string;
  document_id: string;
  filePath: string;
  docNames: string;
  documentTitle?: string;
  uploadBy?: string;
  description?: string;
  super_class?: string;
  criterion?: string;
  type?: string;
  isDeleted?: boolean;
  isNew?: boolean;
}

export interface AddBundledDocumentRequest extends CreateDocumentRequest {
  parent_document_id: string;
}

export type CreateDocumentBatchItem = Omit<
  CreateDocumentRequest,
  "individual_id"
>;

export interface CreateDocumentsBatchRequest {
  individual_id: string;
  documents: CreateDocumentBatchItem[];
}

export interface Document {
  id: string;
  individual_id: string;
  filePath: string;
  docNames: string;
  documentTitle?: string;
  uploadBy?: string;
  description?: string;
  super_class?: string;
  criterion?: string;
  type?: string;
  uploadDate: string;
  isDeleted: boolean;
  isNew?: boolean;
}

export const CaseDocumentsAPI = {
  async create(data: CreateDocumentRequest): Promise<Document> {
    try {
      const response = await axiosInstance.post("/documents", data);
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async createBundle(data: AddBundledDocumentRequest): Promise<Document> {
    try {
      const response = await axiosInstance.post("/documents/bundle", data);
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async createBatch(data: CreateDocumentsBatchRequest): Promise<Document[]> {
    try {
      const response = await axiosInstance.post("/documents/batch", data);
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  }
};
